import styled from 'styled-components';
import colors from '@monorepo-zazuu/shared/constants/colors';

export const Container = styled.div`
  display: inline-flex;
`;

export const TagButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.6rem;
  border-radius: 10rem;
  background-color: ${colors.gray.dark02};
  color: ${colors.gray.white};
  font-family: 'Manrope', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  white-space: nowrap;
  cursor: pointer;
  border: none;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${colors.gray.dark01};
  }
`;

export const CountBadge = styled.span<{ variant: 'reschedule' | 'professional' }>`
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.1rem 0.5rem;
  border-radius: 10rem;
  font-size: 1rem;
  font-weight: 700;
  background-color: ${(props) =>
    props.variant === 'reschedule' ? colors.suport.warning : colors.suport.blue};
  color: ${colors.gray.white};
`;

export const Dropdown = styled.div<{ $top: number; $left: number; $placement: 'top' | 'bottom' }>`
  position: fixed;
  top: ${(props) => (props.$placement === 'bottom' ? `${props.$top}px` : 'auto')};
  bottom: ${(props) => (props.$placement === 'top' ? `calc(100vh - ${props.$top}px)` : 'auto')};
  left: ${(props) => `${props.$left}px`};
  transform: translateX(-50%);
  background-color: ${colors.gray.dark01};
  color: ${colors.gray.white};
  font-family: 'Open Sans', sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  padding: 1rem 1.2rem;
  border-radius: 0.4rem;
  z-index: 9999;
  min-width: 28rem;
  max-width: 40rem;
  max-height: 30rem;
  overflow-y: auto;

  &::after {
    content: '';
    position: absolute;
    ${(props) => (props.$placement === 'top' ? 'top: 100%;' : 'bottom: 100%;')}
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    ${(props) =>
      props.$placement === 'top'
        ? `border-top-color: ${colors.gray.dark01};`
        : `border-bottom-color: ${colors.gray.dark01};`}
  }
`;

export const LogItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.6rem 0;
  border-bottom: 1px solid ${colors.gray.dark02};

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  &:first-child {
    padding-top: 0;
  }
`;

export const LogDescription = styled.p`
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.5;
  color: ${colors.gray.white};
  margin: 0;
  word-break: break-word;
  white-space: normal;
`;

export const LogMeta = styled.p`
  font-size: 1.1rem;
  color: ${colors.gray.dark03};
  margin: 0;
`;

export const LogTypeBadge = styled.span<{ variant: 'reschedule' | 'professional' }>`
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.1rem 0.5rem;
  border-radius: 10rem;
  font-size: 1rem;
  font-weight: 700;
  background-color: ${(props) =>
    props.variant === 'reschedule' ? colors.suport.warning : colors.suport.blue};
  color: ${colors.gray.white};
  width: fit-content;
  margin-bottom: 0.2rem;
`;

export const EmptyMessage = styled.p`
  font-size: 1.2rem;
  color: ${colors.gray.dark03};
  margin: 0;
  text-align: center;
`;
